module.exports = __webpack_public_path__ + "img/image7.0da8f65c.png";